import Alert from 'react-bootstrap/Alert';
import { AttributeFormState } from "@idw-types/state/attribute-form-state";

type UnknownInputProps = {
	attribute: AttributeFormState;
};

export const UnknownInput = (props: UnknownInputProps) => {
	const { attribute } = props;
	return (
		<div>
			<Alert variant="danger">
				The attribute {attribute.type} has no corresponding input handler!
			</Alert>
		</div>
	);
};